module.exports = __webpack_public_path__ + "resources/img/img_hyper_personal_m_en.15aa7cfaa971676e3e7c23fd2ebcff70.png";